import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { IPaymentGeneralTabProps, TNotificationMode } from '@/@types/insurance';

export function PaymentGeneralTab({
  gracePeriodDays,
  smsFallbackDays,
  notificationMode,
  onGracePeriodDaysChange,
  onSmsFallbackDaysChange,
  onNotificationModeChange,
}: IPaymentGeneralTabProps) {
  return (
    <div className="space-y-6 py-4">
      <div className="space-y-2">
        <Label htmlFor="payment-notification-mode">Notification sending mode</Label>
        <Select
          value={notificationMode}
          onValueChange={val => onNotificationModeChange(val as TNotificationMode)} // AS_JUSTIFIED: Select value constrained to 'automatic'|'manual' by SelectItem values
        >
          <SelectTrigger id="payment-notification-mode" className="max-w-[280px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="automatic">Automatic (daily cron)</SelectItem>
            <SelectItem value="manual">Manual (send button)</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          {notificationMode === 'automatic'
            ? 'Notifications are sent automatically every day at 9:00 AM UTC.'
            : 'Notifications are only sent when you click the "Send Now" button on the payments page.'}
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="grace-period-days">Grace period (days after policy issue)</Label>
        <Input
          id="grace-period-days"
          type="number"
          min={0}
          max={365}
          value={gracePeriodDays}
          onChange={e => onGracePeriodDaysChange(parseInt(e.target.value, 10) || 0)}
          className="max-w-[140px]"
        />
        <p className="text-xs text-muted-foreground">
          Policies will not appear in the payments queue until this many days after issue. (0–365)
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="payment-sms-fallback-days">SMS fallback delay (days)</Label>
        <Input
          id="payment-sms-fallback-days"
          type="number"
          min={1}
          max={30}
          value={smsFallbackDays}
          onChange={e => onSmsFallbackDaysChange(parseInt(e.target.value, 10) || 1)}
          className="max-w-[140px]"
        />
        <p className="text-xs text-muted-foreground">
          After email is sent, also send SMS if no payment received within this many days. (1–30)
        </p>
      </div>
    </div>
  );
}
